import ChangePassword from "./ChangePassword";
import { ChangePasswordPayload, ChangePasswordProps } from "./ChangePassword";
export default ChangePassword;
export type { ChangePasswordPayload, ChangePasswordProps }